// Etiqueta del punt de referència de la pinya (històricament, l'ajuntament).
// L'etiqueta i l'emoji efectius es resolen: override de la prova → valor per
// defecte de la colla → "Ajuntament" / heurística de l'emoji.

export const DEFAULT_REFERENCE_LABEL = 'Ajuntament';
export const MAX_REFERENCE_LABEL_LENGTH = 30;

// Sentinella per "explícitament sense emoji" (diferent de '' = heretar)
export const NO_REFERENCE_EMOJI = 'none';

// Opcions del selector d'emoji del modal
export const REFERENCE_EMOJI_OPTIONS = [
    '🏛️', '📍', '☕', '📚', '⛪', '🏫',
    '🏠', '🚪', '🌳', '⛲', '🎪', '🏟️',
    '🥁', '🧭', '🎯', '⭐',
];

export const getEffectiveReferenceLabel = (provaLabel, collaDefaultLabel) =>
    (provaLabel || '').trim() ||
    (collaDefaultLabel || '').trim() ||
    DEFAULT_REFERENCE_LABEL;

// L'etiqueta i l'emoji funcionen com una parella: si la prova té override
// (etiqueta o emoji propis), l'emoji és exactament el de la prova (buit = cap,
// i "none" = cap explícit encara que no hi hagi nom). Només s'hereta l'emoji
// de la colla quan no hi ha cap override.
export const getEffectiveReferenceEmoji = (provaLabel, provaEmoji, collaDefaultEmoji) => {
    const emoji = (provaEmoji || '').trim();

    if (emoji === NO_REFERENCE_EMOJI) return '';
    if (emoji !== '') return emoji;

    const hasLabelOverride = (provaLabel || '').trim() !== '';
    return hasLabelOverride ? '' : (collaDefaultEmoji || '').trim();
};

export const sanitizeReferenceLabel = (label) => {
    if (typeof label !== 'string') return '';

    return label
        .replace(/[\r\n]+/g, ' ')
        .trim()
        .slice(0, MAX_REFERENCE_LABEL_LENGTH)
        .trim();
};
